<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <form>
        <vs-input
          class="inputx mb-4 mt-1"
          v-model="model.name"
          name="segmentName"
          :label="$t('Title')"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('segmentName')">{{
          errors.first("segmentName")
        }}</span>
        <vs-button
          type="filled"
          class="float-right mb-4"
          @click.prevent="submitForm"
          :disabled="disabled"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<style lang="scss">
.vs-con-input input {
  text-align: right;
}
</style>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";

const dict = {
  custom: {
    segmentName: {
      required: "لطفا نام گروه محصول را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "saleManagement_BasicDefinitions_productSegment_ModifyPopup",
  props: {
    show: { default: false },
    model: {
      default: {},
    },
  },
  data() {
    return {
      popupTitle: "",
      disabled: false,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createProductSegment: "productSegment/create",
      updateProductSegment: "productSegment/update",
    }),
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.disabled = true;
          if (this.model.segmentId != null) {
            this.updateProductSegment(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disabled = false;
            });
          } else {
            this.createProductSegment(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disabled = false;
            });
          }
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        if (this.model.segmentId) {
          this.popupTitle = "EditProductSegment";
        } else {
          this.popupTitle = "CreateNewProductSegment";
        }
      }
      this.$validator.reset();
      this.disabled = false;
    },
  },
};
</script>
